import * as semrush from '@anm/helpers/semrush';
import { useSelector } from 'react-redux';

import { AccountTab } from '..';
import { userSelectors } from '../../../../store/modules/user';

const isSemrush = semrush.isSemrushIframe();

export const MANAGE_TEAM = 'Manage Team';
export const PROFILE = 'Profile';
export const YOUTUBE_WHITELIST = 'YouTube Whitelist';

type GetTabsMapProps = {
  isTeamUser: boolean;
};
const getTabsMap = ({ isTeamUser }: GetTabsMapProps) =>
  ({
    profile: PROFILE,
    'youtube-whitelist': YOUTUBE_WHITELIST,
    ...(isTeamUser && { 'manage-team': MANAGE_TEAM })
  } as {
    [key in AccountTab]: typeof MANAGE_TEAM | typeof PROFILE | typeof YOUTUBE_WHITELIST;
  });

const getSectionTabs = () =>
  isSemrush ? ['', YOUTUBE_WHITELIST, MANAGE_TEAM] : [PROFILE, YOUTUBE_WHITELIST, MANAGE_TEAM];

const useTabs = () => {
  const maxTeamUsers = useSelector(userSelectors.selectMaxTeamUsers);
  const isTeamUser = !!maxTeamUsers && maxTeamUsers > 1;
  const tabsNames = getSectionTabs().filter(tab => tab !== MANAGE_TEAM || isTeamUser);
  const tabsMap = getTabsMap({ isTeamUser });

  return { tabsNames, tabsMap };
};

export default useTabs;
